// extracted by mini-css-extract-plugin
export default {"paginationItem":"paginationItem-cfa0a","disabled":"disabled-cfa0a","active":"active-cfa0a","icon":"icon-cfa0a","shine":"shine-cfa0a"};